import { useStandardProductContext } from "app/providers/StandardProductProvider";
import LoadingLayout from "features/shared/loading-layout";
import Container from "shared/ui/container";
import { isDevelopmentEnvironment } from "shared/utils/checkEnvironment";
import { twMerge } from "tailwind-merge";
import ConfiguratorOptions from "widgets/configurator/options";
import ConfiguratorProduct from "widgets/configurator/product";
import Samples from "../../widgets/samples";
import { MobileConfigurator } from "pages/mobile-configurator/MobileConfigurator";
import { useScreenSize } from "app/hooks/shared/useScreenSize";

const Configurator = () => {
  const { showStandardProducts, isKleurStaalCategory } =
    useStandardProductContext();

  const { isMobileScreen } = useScreenSize();

  if (isMobileScreen && !showStandardProducts) {
    return (
      <>
        <LoadingLayout isStandardProduct={false} />
        <MobileConfigurator />
      </>
    );
  }
  return (
    <>
      <main
        className={twMerge(
          isDevelopmentEnvironment() ? "gg-pt-7 md:gg-pt-8" : "",
          "-gg-mt-10 gg-pb-24 sm:gg-mt-0",
        )}
      >
        <Container
          className={twMerge(
            isDevelopmentEnvironment() ? "gg-gap-4 gg-p-6" : "",
            "gg-relative gg-grid gg-grid-cols-12 gg-items-start 2xl:!gg-max-w-screen-xl",
          )}
        >
          <LoadingLayout isStandardProduct={showStandardProducts} />

          {!isKleurStaalCategory && (
            <div className="gg-relative gg-col-span-12 gg-grid gg-h-max gg-grid-cols-12 gg-items-start">
              <ConfiguratorOptions className="gg-order-2 gg-col-span-12 lg:gg-order-1 lg:gg-col-span-5" />
              <ConfiguratorProduct className="gg-order-1 gg-col-span-12 gg-mb-4 lg:gg-order-2 lg:gg-col-span-7 lg:gg-mb-0 lg:gg-ml-12" />
            </div>
          )}

          {showStandardProducts && isKleurStaalCategory && (
            <Samples
              id="standard-product-sample-component"
              className="gg-order-3 gg-col-span-12 gg-mb-10 gg-mt-4 md:gg-mt-12"
            />
          )}
        </Container>
        <div
          id="footersGridElements"
          className="gg-container gg-fixed gg-bottom-0 gg-left-0 gg-z-50 gg-order-last gg-mx-auto gg-w-full"
        ></div>
      </main>
    </>
  );
};

export default Configurator;
